<div class="flex flex-col">
	<a
		*ngFor="let admin of admins$ | async"
		emailLinkInterceptor
		[mailto]="admin.email"
		[subject]="subject"
		class="flex gap-1 anchor"
	>
		<atomic-name-badge
			size="xsmall"
			[firstName]="admin.firstName"
			[lastName]="admin.lastName"
		></atomic-name-badge>
		<span>{{ admin | businessUserName }}</span>
		<app-icon [icon]="ICON.EMAIL"></app-icon>
	</a>
</div>

<div class="py-3 flex w-full gap-2 items-center text-grey-light">
	<span class="h-0 w-full border-grey-veryLight border-t"></span><span>or</span
	><span class="h-0 w-full border-grey-veryLight border-t"></span>
</div>

<div class="flex justify-center">
	<a
		emailLinkInterceptor
		[mailto]="allEmailList$ | async"
		[subject]="subject"
		class="flex gap-1 anchor"
	>
		<app-icon [icon]="ICON.EMAIL"></app-icon>
		<span>Email all admins</span></a
	>
</div>
